@if (custom) {
  <div class="marker" [style.background-color]="custom.bgColor || 'black'" [style.color]="custom.textColor || 'white'">
    {{ custom.name[0] }}
  </div>
}
